<chat-window #chatWindow [ngClass]="{'fullscreen-font': _$fullScreen}" [embeddedMode]="false" [theme]="_$mixingTheme"
    [chatToolsConfig]="_$chatToolsConfig" [chatToolsWidth]="'640px'"
    [messageTimeout]="180" [messageConverter]="_$messageConverter"
    [messageConverterContext]="this" [topMessageModule]="_$topMessage" (addChat)="_$addChat()"
    [messageEditorPlaceholder]="'Please enter the content you need insight'" [topMessageShape]="'collapse'" [chatToolsLayout]="'overlap'"
    (messageInteract)="_$messageInteract($event)" (messageChange)="_$onMessageChange($event)"
    (messageStopped)="_$onMessageStopped($event)"></chat-window>
